<template>
    <div class="table-layout table-patient table-clinical">
        <div class="matrix-panel">
            <div class="table-layout table-patient table-clinical">
                <div class="table-head head-fixed">
                    <div class="table-tr">
                        <div class="table-th cell-availability-th">{{ __('Cancelled date') }}</div>
                        <div class="table-th cell-availability-th">{{ __('Replacement date') }}</div>
                        <div class="table-th cell-availability-th">{{ __('Duration') }}</div>
                    </div>
                </div>
                <div class="table-body">
                    <template v-for="(record, i) in records">
                        <RecordsListRow :key="i" :record="record" :type="type" />
                    </template>
                </div>
            </div>
        </div>
    <!-- <button @click="loadMore" v-if="page !== 0 && records.length >= 5">{{ __('Load more') }}</button> -->
    </div>
</template>

<script>
import RecordsListRow from './RecordsListRow'

export default {
    components: {
        RecordsListRow
    },
    props: {
        records: {
            type: Array,
            required: true
        },
        type: {
            type: String,
            required: true
        },
        coach: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            page: 1
        }
    },
    methods: {
        fetch() {
            return axios.get(`/coaches/${this.coach.id}/availability/history/${this.type}?page=${this.page}`).thenData()
        },
        async loadMore() {
            this.page += 1

            const data = await this.fetch()

            if (data.length) {
                this.$emit('add', { data, type: this.type })
            }

            if (data.length < 5) {
                this.page = 0
            }
        }
    }
}
</script>
